import * as React from 'react';
import { FieldHookConfig } from 'formik';
import { useDropzone } from 'react-dropzone';
import { styled } from '@material-ui/core';
//import fileDownload from 'js-file-download';
import { TextFieldProps } from 'app/components/TextField';
//import { Button } from 'app/components/BasicButtons/Button';
import { ImprotData } from '../Data';

export interface SelectFileProps {
  accept: any;
  downloadFileName?: string;
  filesPlaceholder: React.ReactNode;
  selectFileHandler: (value: boolean) => void;
}

/**
 * Multiline text field with and option to update value by dropping a file
 * @param param0
 * @returns
 */
export const SelectFile = ({
  label,
  onBlur,
  value,
  name,
  error,
  helperText,
  accept,
  downloadFileName,
  filesPlaceholder,
  selectFileHandler,
  ...props
}: FieldHookConfig<string> & TextFieldProps & SelectFileProps) => {
  const onDrop = React.useCallback(
    (acceptedFiles: File[]) => {
      // Do something with the files
      const file = acceptedFiles[0];
      ImprotData.Init(file);
      selectFileHandler(file !== undefined);
    },
    [selectFileHandler],
  );

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
    maxSize: 1000000,
    accept: {
      'application/imp': [accept],
    },
  });

  const files = acceptedFiles.map(file => (
    <li key={file.name}>
      {file.name} - {file.size} bytes
    </li>
  ));

  /*const handleDownloadClick = () => {
    if (downloadFileName !== undefined && fileContent !== null) {
      fileDownload(fileContent, downloadFileName);
    }
  };*/

  return (
    <>
      <StyledDropboxContainer {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p>{filesPlaceholder}</p>
      </StyledDropboxContainer>
      <aside>
        <h4>Files</h4>
        <ul>{files}</ul>
        {/*} <Button variant="text" size="small" onClick={handleDownloadClick}>
          {downloadFileName}
         </Button>*/}
      </aside>
    </>
  );
};
const StyledDropboxContainer = styled('div')(({ theme }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: '2px',
  borderRadius: '2px',
  borderColor: theme.palette.common.grayBorders,
  borderStyle: 'dashed',
  backgroundColor: theme.palette.background.paper,
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
}));
